import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "vevo-detail-wrapper" }
const _hoisted_2 = { class: "vevo-topbar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center pa-6"
}
const _hoisted_5 = {
  key: 1,
  class: "vevo-empty"
}
const _hoisted_6 = {
  key: 2,
  class: "vevo-detail-body"
}
const _hoisted_7 = { class: "vevo-detail-card" }
const _hoisted_8 = { class: "vevo-detail-header" }
const _hoisted_9 = { class: "vevo-detail-icon-wrap" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "vevo-new-badge"
}
const _hoisted_12 = { class: "vevo-detail-titlewrap" }
const _hoisted_13 = { class: "vevo-detail-date" }
const _hoisted_14 = { class: "vevo-detail-title" }
const _hoisted_15 = {
  key: 0,
  class: "vevo-coverage-note"
}
const _hoisted_16 = { class: "vevo-detail-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        icon: "",
        variant: "text",
        size: "small",
        class: "vevo-back-btn",
        onClick: _ctx.goBack,
        ripple: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.chevronLeftIcon,
            alt: "back",
            class: "vevo-back-icon"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "vevo-topbar-title" }, "VEVOレポート", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "vevo-topbar-spacer" }, null, -1))
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (!_ctx.detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " レポートが見つかりませんでした。 "))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: _ctx.envelopeIconRead,
                    alt: "",
                    class: "vevo-detail-icon"
                  }, null, 8, _hoisted_10),
                  (_ctx.isUnread)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "NEW"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatPublishedAt(_ctx.detail.publishedAt)) + " 公開 ", 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.detail.title), 1)
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "vevo-divider" }, null, -1)),
              (_ctx.detail.dataCoverageMonths.length < 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.coverageMessage) + "にデータがある場合に生成しています。 ", 1))
                : _createCommentVNode("", true),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "vevo-coverage-note caution-text" }, "※この文章は、保育士が確認したお子さまの成長のようすをもとに作成されておりますが、AIによるデータの解釈の違いによって、間違った情報になる可能性があります。", -1)),
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.detail.content), 1),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "vevo-divider" }, null, -1))
            ])
          ]))
  ]))
}